import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'crewnik','crewname','crewkey','outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/loan${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    listAngsuran(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1','tgl2','crewname','pinjamanNo','docrefer','modeGet'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                if (obj.modeGet=='exportXls') {
                    const resp = await axios({
                        url: `/loan-report/angsuran${str}`,
                        method: 'GET',
                        responseType: 'blob', // important
                    });
                    resolve(resp);        
                } else {
                    const url = `/loan-report/angsuran${str}`;
                    const { data } = await axios.get(url);
                    // console.log('aging data: ',data);
                    resolve(data);    
                }
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(frm) {
        console.log('save ', frm)
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post('/loan', frm);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/loan/${obj.loankey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/loan/detail/${obj.loankey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'crewnik', 'crewname', 'crewkey', 'outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/loan/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'loan_list.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    aging(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['modeGet', 'tgl2', 'excludezero'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                if (obj.modeGet=='exportXls') {
                    const resp = await axios({
                        url: `/loan-report/aging${str}`,
                        method: 'GET',
                        responseType: 'blob', // important
                    });
                    resolve(resp);        
                } else {
                    const url = `/loan-report/aging${str}`;
                    const { data } = await axios.get(url);
                    // console.log('aging data: ',data);
                    resolve(data);    
                }
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    markSkip(obj) {
        return new Promise(async (resolve, reject) => {
            try {             
                const keys = ['skip_time', 'skip_reason', 'arrKey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        if (key=='arrKey') {
                            str += key + '=' + encodeURIComponent(JSON.stringify(obj.arrKey));
                        } else {
                            str += key + '=' + encodeURIComponent(obj[key]);
                        }
                    }
                }

                const { data } = await axios.put(`/loan/mark-skip?${str}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    markPaid(obj) {
        return new Promise(async (resolve, reject) => {
            try {             
                const keys = ['paym_date', 'paym_remark', 'arrKey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        if (key=='arrKey') {
                            str += key + '=' + encodeURIComponent(JSON.stringify(obj.arrKey));
                        } else {
                            str += key + '=' + encodeURIComponent(obj[key]);
                        }
                    }
                }

                const { data } = await axios.put(`/loan/mark-paid?${str}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    markUnPaid(arrKey) {
        return new Promise(async (resolve, reject) => {
            try {                
                const { data } = await axios.put(`/loan/mark-unpaid?arrKey=${encodeURIComponent(JSON.stringify(arrKey))}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    

};